import { ref as d } from "vue";
import { isValid as h, addMinutes as m } from "date-fns";
import { A as f } from "../lib/api.DveR7HGv.js";
const l = /* @__PURE__ */ new Map(), g = 60 * 4, I = 15, C = (i, t) => {
  const o = new Date(localStorage.getItem(`${i}Expires`));
  return {
    functionPromise: d(null),
    itemsAreHydrated: !1,
    cacheUserId: localStorage.getItem(`${i}UserId`) || "",
    items: localStorage.getItem(`${i}`) || "[]",
    itemsExpire: h(o) ? o : (
      /* v8 ignore next */
      0
    ),
    expiryCheckTime: 0,
    options: {
      cacheTimeMinutes: g,
      expiryCheckTimeMinutes: I,
      ...t
    }
  };
}, u = async () => {
  var t;
  const i = (t = document.cookie.split(";").find((o) => o.trim().includes("LastAuthUser="))) == null ? void 0 : t.split("=")[1].trim();
  return i || "";
};
let c = null;
const E = async (i, t, o, r) => {
  let s = !0;
  if (!l.has(t))
    throw new Error(`pinia cache: ${t} cache not found`);
  const e = l.get(t);
  return e.functionPromise.value != null && typeof e.functionPromise.value.then == "function" ? e.functionPromise.value : (e.itemsAreHydrated && e.items.length == 0 && (s = !1), (e.itemsExpire == 0 || e.itemsExpire <= /* @__PURE__ */ new Date()) && (s = !1), c === null && (c = await u()), e.cacheUserId !== c && (s = !1, console.debug(`pinia cache: ${t} cache avoid - user changed`)), s ? (console.debug(`pinia cache: ${t} cache hit`), e.itemsAreHydrated === !1 && (console.debug("pinia cache: rehydrating from localstorage"), e.items = f.transformResponse(e.items), e.itemsAreHydrated = !0), r !== null && (e.expiryCheckTime == 0 || e.expiryCheckTime <= /* @__PURE__ */ new Date()) && (r(o, e.items).then((a) => {
    a === !0 && (e.itemsExpire = 0);
  }), e.expiryCheckTime = m(
    /* @__PURE__ */ new Date(),
    e.options.expiryCheckTimeMinutes
  )), e.items) : (console.debug(`pinia cache: ${t} cache miss`), e.functionPromise.value = i.call(o).then((a) => (e.items = a, e.itemsAreHydrated = !0, localStorage.setItem(t, JSON.stringify(a)), e.itemsExpire = m(
    /* @__PURE__ */ new Date(),
    e.options.cacheTimeMinutes
  ), localStorage.setItem(
    `${t}Expires`,
    e.itemsExpire.toISOString()
  ), e.cacheUserId = c, localStorage.setItem(`${t}UserId`, e.cacheUserId), e.expiryCheckTime = m(
    /* @__PURE__ */ new Date(),
    e.options.expiryCheckTimeMinutes
  ), e.items)).finally(() => {
    e.functionPromise.value = null;
  }), e.functionPromise.value));
}, y = (i, t) => {
  Array.isArray(t) || (t = [t]), t.forEach((o) => {
    const r = `${i.$id}.${o}`;
    if (l.has(r)) {
      console.debug(`pinia cache: ${r} cache reset`);
      const s = l.get(r);
      s.items = [], s.itemsExpire = 0, s.cacheUserId = "", s.expiryCheckTime = 0, localStorage.removeItem(r), localStorage.removeItem(`${r}Expires`), localStorage.removeItem(`${r}UserId`);
    }
  });
};
function k(i) {
  var t, o;
  u().then((r) => {
    c = r;
  }), (o = (t = i.options) == null ? void 0 : t.localStorageCache) == null || o.forEach((r) => {
    var a;
    const s = `${i.store.$id}.${r.function}`;
    l.set(s, C(s, r == null ? void 0 : r.options));
    let e = null;
    r.expiryCheckFunction && (e = i.options.actions[r.expiryCheckFunction]);
    for (const [n, p] of Object.entries((a = i.options) == null ? void 0 : a.actions))
      n === r.function && (i.store[n] = () => E(p, s, i.store, e));
    i.store.localStorageInvalidateCache = (n) => y(i.store, n), i.store.localStorageRefreshAuthUserId = async () => {
      const n = await u();
      return c = n, n;
    };
  });
}
export {
  k as p
};
